import React from 'react';
import { Briefcase, MapPin, Calendar } from 'lucide-react';
import { experienceData } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 bg-[#faf6ee]" data-testid="experience-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-gold-400/10 text-gold-400 text-sm font-semibold rounded-full mb-4">
            Career Journey
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#152846] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Professional <span className="text-gold-400">Experience</span>
          </h2>
          <p className="text-lg text-[#5c6878] max-w-2xl mx-auto">
            Over two decades of leadership experience across HR, IT consulting, and business operations
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-px bg-gold-400/20 transform md:-translate-x-1/2" />

          <div className="space-y-12">
            {experienceData.map((exp, index) => (
              <div
                key={exp.id}
                className={`relative flex flex-col md:flex-row gap-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="absolute left-0 md:left-1/2 w-4 h-4 bg-gold-400 rounded-full border-4 border-[#faf6ee] shadow transform -translate-x-1/2 md:-translate-x-1/2 z-10" />

                <div className={`ml-8 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'}`}>
                  <div className="bg-[#fffdf8] p-6 rounded-2xl border border-[#e6dfd0] hover:border-gold-400/30 hover:shadow-lg hover:shadow-gold-400/5 transition-all duration-300" data-testid={`experience-card-${index}`}>
                    <div className="flex items-start gap-4 mb-4">
                      <div className="w-12 h-12 bg-gold-400/10 rounded-xl flex items-center justify-center flex-shrink-0">
                        <Briefcase className="w-6 h-6 text-gold-400" strokeWidth={2.5} />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-[#152846]">{exp.role}</h3>
                        <p className="text-gold-400 font-semibold">{exp.company}</p>
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-4 mb-4 text-sm text-[#8b94a3]">
                      <span className="flex items-center gap-1"><Calendar size={14} strokeWidth={2.5} />{exp.duration}</span>
                      <span className="flex items-center gap-1"><MapPin size={14} strokeWidth={2.5} />{exp.location}</span>
                    </div>
                    <p className="text-[#5c6878] leading-relaxed">{exp.description}</p>
                  </div>
                </div>

                <div className="hidden md:block md:w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
